import { isFunction } from "@common/TypesHelper";

export const getElementOffsetWidth = (element: HTMLElement | undefined, fallback = 0) => {
    return element?.offsetWidth || fallback;
}

export const removeStylesFromDOM = (className: string) => {
    const styleElements = document.getElementsByClassName(className);
    Array.from(styleElements).forEach((element) => element.remove());
}

export const addStylesToHead = (css: string, className = "") => {
    const head = document.head || document.getElementsByTagName('head')[0];
    const style = document.createElement('style');
    style.classList.add(className);

    head.appendChild(style);
    style.appendChild(document.createTextNode(css));
}

// Returns true if the parent element contains the child element
export const contains = (parent: HTMLElement | null, child: HTMLElement | null) =>
    parent && isFunction(parent.contains) ? parent.contains(child) : false